import { makeLegendFormatter } from '../utils/legend-formatter.js'
import { dateFormatterInit } from '../utils/date-formatter.js'

const noxChartOptions = {
  height: 320,
  labels: [
    'Datetime',
    'NOX Index'
  ],
  series: {
    'NOX Index': {
      axis: 'y'
    }
  },
  axes: {
    x: dateFormatterInit(),
    y: {
      valueRange: [0, 500],
      axisLabelWidth: 50,
      independentTicks: true,
      axisLabelFormatter: (y) => y.toFixed(0)
    }
  },
  colors: ['#E67E22'],
  labelsDiv: 'legendDivNOX',
  labelsSeparateLines: false,
  legend: 'always',
  legendFormatter: makeLegendFormatter((data) => {
    return data
  }),
  animatedZooms: true
}

export {
  noxChartOptions
}